(function () {
  function initMediaSlider(section) {
    const slider = section.querySelector('.featured-product-custom__slider-init');
    if (!slider || slider.classList.contains('swiper-container-initialized')) return;

    const slideCount = section.querySelectorAll(
      '.featured-product-custom__slider-init .swiper-slide'
    ).length;
    if (slideCount < 2) return;

    section.querySelector('.featured-product-custom__slider-wrap')?.classList.add('init');

    new Swiper(slider, {
      slidesPerView: 1.08,
      spaceBetween: 12,
      pagination: {
        clickable: true,
        el: section.querySelector('.featured-product-custom__pagination'),
      },
    });
  }

  function initReviewsSlider(section) {
    section
      .querySelectorAll('.featured-product-custom__reviews-slider-init')
      .forEach((slider) => {
        if (slider.classList.contains('swiper-container-initialized')) return;

        const slideCount = slider.querySelectorAll('.swiper-slide').length;
        if (slideCount < 2) return;

        const reviews = slider.closest('.featured-product-custom__reviews');

        new Swiper(slider, {
          slidesPerView: 1.3,
          spaceBetween: 16,
          navigation: {
            nextEl: reviews?.querySelector('.featured-product-custom__reviews-arrow--next'),
            prevEl: reviews?.querySelector('.featured-product-custom__reviews-arrow--prev'),
          },
          pagination: {
            el: reviews?.querySelector('.featured-product-custom__reviews-progress'),
            type: 'progressbar',
          },
        });
      });
  }

  function initVideoSliders(section) {
    section
      .querySelectorAll('.featured-product-custom__video-slider-init')
      .forEach((slider) => {
        if (slider.classList.contains('swiper-container-initialized')) return;

        const slideCount = slider.querySelectorAll('.swiper-slide').length;
        if (slideCount < 2) return;

        new Swiper(slider, {
          slidesPerView: 2.3,
          spaceBetween: 16,
          breakpoints: {
            750: {
              slidesPerView: 3.3,
            },
          },
        });
      });
  }

  function pauseVideoCard(card) {
    const video = card.querySelector('video');
    if (!video) return;

    video.pause();
    card.classList.remove('is-playing');
  }

  function revealVideoSlideIfNeeded(card) {
    const slide = card.closest('.featured-product-custom__video-slide');
    const slider = card.closest('.featured-product-custom__video-slider-init');
    const swiper = slider?.swiper;

    if (!slide || !slider || !swiper) return false;

    const viewport = slider.closest('.featured-product-custom__video-reviews') || slider;
    const slideRect = slide.getBoundingClientRect();
    const viewportRect = viewport.getBoundingClientRect();
    const tolerance = 1;
    const isFullyVisible =
      slideRect.left >= viewportRect.left - tolerance &&
      slideRect.right <= viewportRect.right + tolerance;

    if (isFullyVisible) return false;

    const slideIndex = Array.from(slider.querySelectorAll('.swiper-slide')).indexOf(slide);
    if (slideIndex === -1) return false;

    swiper.slideTo(slideIndex);
    return true;
  }

  function initVideoPlayback(section) {
    section
      .querySelectorAll('.featured-product-custom__video-card')
      .forEach((card) => {
        if (card.dataset.videoPlaybackInit === 'true') return;
        card.dataset.videoPlaybackInit = 'true';

        const video = card.querySelector('video');
        if (!video) return;

        card.addEventListener('click', () => {
          revealVideoSlideIfNeeded(card);

          if (video.paused) {
            section
              .querySelectorAll('.featured-product-custom__video-card.is-playing')
              .forEach((playingCard) => {
                if (playingCard !== card) pauseVideoCard(playingCard);
              });

            const playPromise = video.play();
            card.classList.add('is-playing');

            if (playPromise) {
              playPromise.catch(() => {
                card.classList.remove('is-playing');
              });
            }
          } else {
            pauseVideoCard(card);
          }
        });

        video.addEventListener('pause', () => {
          card.classList.remove('is-playing');
        });

        video.addEventListener('ended', () => {
          card.classList.remove('is-playing');
        });
      });
  }

  function getScrollTarget(anchor, section) {
    if (!anchor || anchor === '#') return section;

    let target = null;

    try {
      target = document.querySelector(anchor);
    } catch (error) {
      target = null;
    }

    if (target) return target;

    const sectionKey = anchor.charAt(0) === '#' ? anchor.slice(1) : anchor;
    return (
      document.getElementById(`shopify-section-${sectionKey}`) ||
      document.querySelector(`[id$="__${sectionKey}"]`) ||
      section
    );
  }

  function scrollToTarget(target) {
    const header = document.querySelector('.site-header');
    const offset = header ? header.offsetHeight : 0;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  }

  function initStickyButton(section) {
    const sticky = section.querySelector('[data-fpc-sticky]');
    if (!sticky || sticky.dataset.fpcStickyInit === 'true') return;

    const mainButton = section.querySelector('[data-fpc-main-submit]');
    const stickyButton = sticky.querySelector('[data-fpc-sticky-button]');
    const footer = document.querySelector('#shopify-section-footer, footer, .site-footer');

    if (!mainButton || !stickyButton) return;

    sticky.dataset.fpcStickyInit = 'true';

    function updateStickyState() {
      const buttonRect = mainButton.getBoundingClientRect();
      const footerVisible = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      const shouldShow = buttonRect.bottom < 0 && !footerVisible;

      sticky.classList.toggle('is-visible', shouldShow);
    }

    stickyButton.addEventListener('click', () => {
      const target = getScrollTarget(sticky.dataset.anchor, section);
      scrollToTarget(target);
    });

    window.addEventListener('scroll', updateStickyState, { passive: true });
    window.addEventListener('resize', updateStickyState);
    updateStickyState();
  }

  function initFeaturedProductCustom(section) {
    initMediaSlider(section);
    initReviewsSlider(section);
    initVideoSliders(section);
    initVideoPlayback(section);
    initStickyButton(section);
  }

  function initAll() {
    document
      .querySelectorAll('.featured-product-custom')
      .forEach(initFeaturedProductCustom);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('.featured-product-custom');
    if (section) initFeaturedProductCustom(section);
  });
})();
